// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__h7MrW","col":"styles_col__3jF0S"};